// eslint-disable-next-line import/prefer-default-export
export const INNOVATOR_TYPE = {
  CAREER: 'career',
  NEW_GRADUATE: 'new_graduate',
  ENGINEER: 'engineer',
} as const;
